define('lq/asyncSubcriptions',[
    'underscore',
    'lq',
    'when',
    'signalr'
], function (_, lq, when, signalR) {
    'use strict';

    var connection = null;
    var groups = {};

    var getRandom = function (min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    };

    var createSubscription = function (register, actionInstanceId, receiverIdentifier, callback) {
        return register()
            .then(function (groupName) {
                if (!groups[groupName]) {
                    groups[groupName] = {
                        subscribers: []
                    };
                }

                var registrationAlreadyExists = !!_.findWhere(groups[groupName].subscribers, {
                    actionInstanceId: actionInstanceId,
                    receiverIdentifier: receiverIdentifier
                });

                if (!registrationAlreadyExists) {
                    groups[groupName].subscribers.push({
                        actionInstanceId: actionInstanceId,
                        receiverIdentifier: receiverIdentifier,
                        callback: callback,
                        register: register
                    });
                }
            });
    };

    var callSubscribers = function (groupName, calleeArguments) {
        _.each(groups[groupName].subscribers, function (subscriber) {
            subscriber.callback.apply(null, calleeArguments);
        });
    };

    var addSubscription = function (initialiseCallback) {
        var deferred = when.defer();
        if ($.connection) {
            require([
                'signalr.hubs'
            ],
                function () {
                    if ($.connection.hub.state == $.connection.connectionState.connected) {
                        initialiseCallback()
                            .then(function () {
                                deferred.resolve();
                            })
                    } else {
                        $.connection.asyncHub.client.receiveResults = function (data) {
                            callSubscribers(data.groupName, ['receiveResults', data.results]);
                        };
                        $.connection.asyncHub.client.deleteResult = function (data) {
                            callSubscribers(data.groupName, ['deleteResult', data.id]);
                        };
                        $.connection.asyncHub.client.receiveEvent = function (data) {
                            callSubscribers(data.groupName, ['receiveEvent', data.eventName, data.argument]);
                        };
                        $.connection.hub.disconnected(function () {
                            var delay = getRandom(200, 2000);

                            setTimeout(function () {
                                $.connection.hub.start()
                                    .then(function () {
                                        _.each(_.keys(groups), function (groupName) {
                                            _.each(groups[groupName].subscribers, function (subscriber) {
                                                subscriber.register();
                                            });
                                        });
                                    });
                            }, delay);
                        });
                        $.connection.hub.logging = true;
                        $.connection.hub.start()
                            .then(function () {
                                return initialiseCallback();
                            })
                            .then(function () {
                                deferred.resolve();
                            });
                    }
                });
        } else {
            connection = new signalR.HubConnectionBuilder()
                .withUrl("/RuntimeHub")
                .withAutomaticReconnect()
                .build();

            connection.on('ReceiveResults', function (data) {
                var capitalizedResults = { // Have to capitalize the keys of the 'results' object unless it won't work
                    outputs: data.results.outputs,
                    results: data.results.results,
                    totalResults: data.results.totalResults
                };
                callSubscribers(data.groupName, ['receiveResults', capitalizedResults]);
            });

            connection.on('DeleteResult', function (data) {
                callSubscribers(data.groupName, ['deleteResult', data.id]);
            });

            connection.on('ReceiveEvent', function (data) {
                callSubscribers(data.groupName, ['receiveEvent', data.eventName, data.argument]);
            });

            connection.connection.onclose(function () {
                var delay = getRandom(200, 2000);

                setTimeout(function () {
                    connection.start().then(function () {
                        _.each(_.keys(groups), function (groupName) {
                            _.each(groups[groupName].subscribers, function (subscriber) {
                                subscriber.register();
                            });
                        });
                    });
                }, delay);
            });

            var start = function () {
                 connection.start().then(function () {
                    try {
                        connection.invoke("OnConnected", lq.getTenantName() + '/' + lq.getTenantApplicationName())
                            .then(function () {
                               initialiseCallback().then(function () {
                                    deferred.resolve();
                                });
                            });
                    } catch (err) {
                        console.error(err);
                    }
                 });
            }
            start();
        }

        return deferred.promise;
    };

    var addDatasourceSubscription = function (piping, receiverIdentifier, filter, callback) {
        filter = piping.parameters.replace(filter);

        var registerDatasourceSubscription = function () {
            if ($.connection) {
                return $.connection.asyncHub.server.addDatasourceListener(
                    lq.getTenantName(),
                    lq.getTenantApplicationName(),
                    piping.actionId,
                    receiverIdentifier,
                    filter);
            } else {
                return connection.invoke("AddDatasourceListener",
                    lq.getTenantName(),
                    lq.getTenantApplicationName(),
                    piping.actionId,
                    receiverIdentifier,
                    filter);
            }
        };

        return addSubscription(function () {
            return createSubscription(registerDatasourceSubscription, piping.actionInstanceId, receiverIdentifier, callback);
        });
    };

    var addEventSubscription = function (piping, receiverIdentifier, filter, callback) {
        filter = piping.parameters.replace(filter);

        var registerEventSubscription = function () {
            if ($.connection) {
                return $.connection.asyncHub.server.addEventListener(
                    lq.getTenantName(),
                    lq.getTenantApplicationName(),
                    piping.actionId,
                    receiverIdentifier,
                    filter);
            } else {
                return connection.invoke("AddEventListener",
                    lq.getTenantName(),
                    lq.getTenantApplicationName(),
                    piping.actionId,
                    receiverIdentifier,
                    filter);
            }
        };

        return addSubscription(function () {
            return createSubscription(registerEventSubscription, piping.actionInstanceId, receiverIdentifier, callback);
        });
    };

    var unsubscribe = function (groupNames) {
        if ($.connection) {
            return $.connection.asyncHub.server.unsubscribe(groupNames);
        } else {
            return connection.invoke("Unsubscribe", groupNames);
        }
    };

    var unsubscribeActionInstance = function (actionInstanceId) {
        _.each(_.keys(groups), function (groupName) {
            groups[groupName].subscribers = _.filter(groups[groupName].subscribers, function (subscriber) {
                return subscriber.actionInstanceId !== actionInstanceId;
            });
        });

        var toClose = _.filter(_.keys(groups), function (groupName) {
            return groups[groupName].subscribers.length === 0;
        });

        if (toClose.length > 0) {   
            unsubscribe(toClose)
                .then(function () {
                    _.each(toClose, function (groupName) {
                        delete groups[groupName];
                    });
                });
        }
    };

    return {

        addDatasourceSubscription: addDatasourceSubscription,
        addEventSubscription: addEventSubscription,
        unsubscribeActionInstance: unsubscribeActionInstance

    };
});
